/* ==========================================================================
   Collection Filters
   - Desktop sidebar toggle
   - Mobile filter drawer
   - Sort dropdown
   - Price range filter
   ========================================================================== */

class CollectionFilters {
  constructor() {
    this.section = document.querySelector('[data-collection]');
    if (!this.section) return;

    this.body = document.querySelector('.collection-main__body');
    this.drawer = document.getElementById('collection-filter-drawer');
    this.overlay = document.querySelector('.collection-main__drawer-overlay');
    this.sortSelect = document.getElementById('collection-sort');
    this.toggleBtn = document.querySelector('[data-filter-toggle]');
    this.mobileBtn = document.querySelector('[data-filter-mobile-btn]');
    this.closeBtn = document.querySelector('[data-filter-close]');
    this.priceForm = document.querySelector('[data-price-filter]');
    this.drawerPriceForm = document.querySelector('[data-price-filter-drawer]');

    this.bindEvents();
  }

  bindEvents() {
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.toggleSidebar());
    }

    if (this.mobileBtn) {
      this.mobileBtn.addEventListener('click', () => this.openDrawer());
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeDrawer());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeDrawer());
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => this.handleSort(e));
    }

    if (this.priceForm) {
      this.priceForm.addEventListener('submit', (e) => this.handlePriceFilter(e));
    }

    if (this.drawerPriceForm) {
      this.drawerPriceForm.addEventListener('submit', (e) => this.handlePriceFilter(e));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isDrawerOpen()) {
        this.closeDrawer();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 780 && this.isDrawerOpen()) {
        this.closeDrawer();
      }
    });
  }

  toggleSidebar() {
    if (!this.body) return;
    const hidden = this.body.hasAttribute('data-filters-hidden');
    const label = this.toggleBtn.querySelector('[data-filter-toggle-label]');
    if (hidden) {
      this.body.removeAttribute('data-filters-hidden');
      if (label) label.textContent = this.toggleBtn.dataset.hideLabel;
    } else {
      this.body.setAttribute('data-filters-hidden', '');
      if (label) label.textContent = this.toggleBtn.dataset.showLabel;
    }
  }

  isDrawerOpen() {
    return this.drawer && this.drawer.getAttribute('aria-hidden') === 'false';
  }

  openDrawer() {
    if (!this.drawer) return;
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('filters-open');
    this.drawer.querySelector('button, a, input')?.focus();
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('filters-open');
    this.mobileBtn?.focus();
  }

  handleSort(e) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  }

  handlePriceFilter(e) {
    e.preventDefault();
    const form = e.target;
    const min = form.querySelector('[name="filter.v.price.gte"]')?.value;
    const max = form.querySelector('[name="filter.v.price.lte"]')?.value;
    const url = new URL(window.location.href);

    if (min) {
      url.searchParams.set('filter.v.price.gte', min);
    } else {
      url.searchParams.delete('filter.v.price.gte');
    }

    if (max) {
      url.searchParams.set('filter.v.price.lte', max);
    } else {
      url.searchParams.delete('filter.v.price.lte');
    }

    window.location.href = url.toString();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});
